var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:#defffb;}.d{fill:#4cecf2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 110,
    height: 110,
    transform: "translate(14682 4679)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-14682 -4679)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13632.18 4175.471)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1052.82 526.195)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1084.452,539.992c-1.926,0-3.165,1.235-3.165,3.411v18.891c0,2.174,1.239,3.411,3.165,3.411s3.165-1.236,3.165-3.411V543.4C1087.617,541.227,1086.384,539.992,1084.452,539.992Z",
    transform: "translate(-1029.752 -513.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1142.956,552.279a21.257,21.257,0,0,0-25.906-12.889,29.412,29.412,0,0,0-54.418,14.827,19.6,19.6,0,0,0,9.794,36.586h65.352a19.61,19.61,0,0,0,5.177-38.523Zm-48.4,6.814h-5.143v-4.055a3.026,3.026,0,1,0-6.034,0v19.186a3.026,3.026,0,1,0,6.034,0V569.28h5.143v4.944a8.208,8.208,0,1,1-16.416,0V555.038a8.208,8.208,0,0,1,16.416,0Zm21.369,14.984c0,4.993-3.365,8.357-8.409,8.357s-8.4-3.364-8.4-8.357V555.186c0-4.993,3.36-8.356,8.4-8.356s8.409,3.364,8.409,8.356Zm16.132,4.6v2.659h-11.767V578.89l5.429-6.57c2.03-2.448,2.625-3.724,2.625-5.159,0-1.3-.8-2.022-2.241-2.022s-2.241.719-2.241,2.022v1.09h-3.572v-.878c0-3.03,2.172-4.893,5.847-4.893s5.92,1.729,5.92,4.6c0,2.02-.807,3.669-3.291,6.675l-4.062,4.921Z",
    transform: "translate(-1052.82 -525.45)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1100.793,527.028v17.524h-5.014a2.488,2.488,0,0,0-2.5,2.5c0,1.159.724,1.738,1.358,2.5L1105.807,563c.779.959,1.394,1.557,2.5,1.557,1.122,0,1.72-.6,2.5-1.557l11.17-13.451c.634-.76,1.358-1.358,1.358-2.5a2.488,2.488,0,0,0-2.5-2.5h-5.014V527.028a2.5,2.5,0,0,0-2.5-2.5h-10.011A2.507,2.507,0,0,0,1100.793,527.028Z",
    transform: "translate(22.785 -6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.f6e2535df77975b9126b33abff64d411.svg";
export { ForwardRef as ReactComponent };